import { Trans } from '@lingui/macro';
import { Box, Button, Flex, TFCard, TFNotifier } from '@tf/ui';
import type React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Greetings } from '@/components/cases/Greetings';
import { reportCaseRequestSubmitError } from '@/components/cases/reportCaseRequestSubmitError';
import { LivenessCheck } from '@/components/shared';
import type { IdentityVerificationRequest } from '@/core/api';
import { useSubmitCaseRequestMutation } from '@/core/api';

interface Props {
	caseRequest: IdentityVerificationRequest;
}

export const LivenessCheckRequest: React.FC<Props> = ({ caseRequest }) => {
	const navigate = useNavigate();
	const [isRequestMessageConfirmed, setIsRequestMessageConfirmed] = useState(false);

	const submitCaseRequest = useSubmitCaseRequestMutation();

	return (
		<TFCard maw="50rem" innerPadding="2rem" flex="1">
			{isRequestMessageConfirmed ? (
				<Box h="66rem" mb="4rem">
					<LivenessCheck
						livenessCheckData={caseRequest.payload}
						onFinish={() => {
							// Guard against submitting more than once (e.g. onFinish firing twice).
							if (submitCaseRequest.isPending) {
								return;
							}

							submitCaseRequest.mutate(
								{
									id: caseRequest.id,
									responseText: '',
									files: [],
								},
								{
									onSuccess: () => {
										navigate('/request-submitted');
									},
									onError: (error) => {
										reportCaseRequestSubmitError(error, {
											caseId: caseRequest.id,
											caseKind: caseRequest.caseKind,
											files: [],
										});
										TFNotifier.error('Error while submitting request');
									},
								},
							);
						}}
					/>
				</Box>
			) : (
				<>
					<Greetings caseNumber={caseRequest.caseId} dueDate={caseRequest.dueDate} />
					<Flex mt="2rem" justify="flex-start">
						<Button onClick={() => setIsRequestMessageConfirmed(true)}>
							<Trans id="caseRequestPage.continueButton">Continue</Trans>
						</Button>
					</Flex>
				</>
			)}
		</TFCard>
	);
};
